"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = __importDefault(require("react-dom"));
var div;
if (typeof document !== 'undefined') {
    // for hot reload, element may already exist
    div = document.getElementById('ff-ui-modal-root');
    if (!div) {
        div = document.createElement('div');
        div.setAttribute('id', 'ff-ui-modal-root');
        document.body.appendChild(div);
    }
}
function ModalPortal(props) {
    if (!div)
        return null;
    return react_dom_1.default.createPortal(props.children, div);
}
exports.default = ModalPortal;
